<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import VConsole from 'vconsole';
import { initWechatJump } from '@/utils/wechat-jump';

export default {
  name: "App",
  components: {},
  created() {
    // 延迟执行：等待路由组件内已有的 wx.config（企微签名）执行完毕，
    // 避免其异步覆盖开放标签的公众号签名
    setTimeout(initWechatJump, 1200);
    const urlParams = new URLSearchParams(window.location.search);
    const testMode = urlParams.get("testMode");
    localStorage.setItem("testMode", testMode || 0);
    if (testMode == 1) {
       new VConsole()

      // 页面加载后动态替换标签文本
      setTimeout(() => {
        const replacements = {
          'Log': '日志',
          'System': '系统',
          'Network': '网络',
          'Element': '元素',
          'Storage': '存储',
          'Clear': '清空',
          'Hide': '隐藏',
          'Switch tab': '切换标签',
          'Tap to switch': '点击切换',
        }

        // 替换标签栏文字
        document.querySelectorAll('.vc-tabbar a').forEach(el => {
          const txt = el.textContent?.trim()
          if (txt && replacements[txt]) {
            el.textContent = replacements[txt]
          }
        })

        // 替换其他按钮
        document.querySelectorAll('.vc-toolbar a, .vc-toolbar button').forEach(el => {
          const txt = el.textContent?.trim()
          if (txt && replacements[txt]) {
            el.textContent = replacements[txt]
          }
        })
      }, 500)
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}

/* Global styles for popups and pickers - should apply across all views */
.van-popup {
  z-index: 99995 !important;
}

.van-datetime-picker {
  z-index: 99996 !important;
}

.van-picker__toolbar {
  z-index: 99997 !important;
}

/* .van-overlay {
  z-index: 99994 !important;
} */
</style>
